<app-patient-info [heading]="Item"></app-patient-info>
<div [hidden]="activatedRoute.children.length > 0">
  <div class="p-fluid grid">
    <div class="col-12"></div>

    <!--<span class="p-float-label">
            <p-dropdown *ngIf="distinctImageList" dataKey="categoryId" [options]="distinctImageList" optionLabel="categoryName"  class="p-fluid" [(ngModel)]="distinctImageresult" (onChange)="Setitem();"></p-dropdown>
        </span>-->
    <div class="grid col-12 bg-white p-0" *ngIf="showCategoryView">
      <div class="col-1 align-content-center p-0">
        <h5 class="align-items-center pt-2 pl-3">Categories:</h5>
      </div>
      <div class="col-11">
        <p-tabMenu
          [model]="distinctImageList"
          [scrollable]="true"
          [activeItem]="activeItem"
        >
          <ng-template pTemplate="item" let-i>
            <a
              class="p-menuitem-link flex justify-content-between align-items-center p-3"
            >
                <p-button [label]="getLabelAndCount(i)"
                          [raised]="true"
                          [rounded]="true"
                          [text]="i.categoryId !== selectedCategoryId"
                          [plain]="i.categoryId !== selectedCategoryId"
                          (click)="setItem(i)"
                          [ngStyle]="{ width: 'max-content' }">
                </p-button>
            </a>
          </ng-template>
        </p-tabMenu>
      </div>
    </div>
  </div>

  <div
       *ngIf="resetState"
    class="search-results grid"
    infiniteScroll
    [infiniteScrollDistance]="5"
    [infiniteScrollThrottle]="50"
    (scrolled)="loadMore()"
  >
    <ng-container *ngIf="arrimagedetails?.data.length > 0; else emptyTemplate">
      <ng-container *ngFor="let i of arrimagedetails?.data">
        <div class="col-3 pt-4">
          <p-card
            [style]="{ width: '100%', cursor: 'pointer' }"
            (click)="showDocument(i)"
            class="card-container"
          >
            <p style="text-align: center">
              @if (i.thumbnail) {
                <img
                  alt="Card"
                  src="{{ i.thumbnail }}"
                  [style]="{ width: '100%' }"
                />
              } @else {
                <img
                  alt="Card"
                  src="{{ '/assets/images/pdficon.png' }}"
                  [style]="{ width: '35%' }"
                  title="file not available"
                />
              }
            </p>
            <ng-template pTemplate="footer">
              <div
                class="blueGradient h-4rem flex align-items-center pl-4 border-round-bottom-xl"
              >
                <div class="align-content-center">
                  {{ i.displayDescription }}
                </div>
              </div>
            </ng-template>
          </p-card>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #emptyTemplate>
      <div class="w-12 bg-white">
        <div class="" style="text-align: center">
          <img
            _ngcontent-ng-c683320295=""
            class="profile-image"
            style="border-radius: 50%; width: 10rem; padding-top: 1rem"
            src="assets/imagesNew/table_error.png"
          />
        </div>
        <hr style="margin-bottom: 0.5rem" />
        <div
          class=""
          style="text-align: center; font-size: larger; color: #1d428f"
        >
          <i>No records found</i>
        </div>
      </div>
    </ng-template>
  </div>

  <!--
    <p-table *ngIf="arrimagedetails" [responsive]="true" [columns]="cols" [value]="arrimagedetails.data" selectionMode="single" [scrollable]="true"
             [resetPageOnSort]="false" [lazy]="false" [rows]="rows" [paginator]="true">



        <ng-template pTemplate="header" let-columns>
            <tr>

                <th *ngFor="let col of columns" [pSortableColumn]="col.field">
                    <p-sortIcon [field]="col.field"></p-sortIcon>
                    {{gridHeader}}


                </th>
                <th>View</th>

            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns" let-i="rowIndex">
            <tr [pSelectableRow]="rowData" >




                <td *ngFor="let col of columns">

                    <span class="column-title">{{gridHeader}}</span>
                    {{rowData[col.field]}}
                </td>
               <td>
                        <button pButton type="button" icon="pi pi-book" class="p-button-plain" (click)="getdocumnetdetails(rowData)"
                                style="font-size: 0.7em;" ></button>

                    </td>

            </tr>

        </ng-template>

        <ng-template pTemplate="emptymessage">
            <tr>
                <td colspan="10">No Records found.</td>
            </tr>
        </ng-template>

    </p-table>-->
</div>

<div [hidden]="activatedRoute.children.length === 0">
  <div class="mt-2">
    <p-button label="Back" (click)="back()"></p-button>
    <hr />
  </div>
  <router-outlet></router-outlet>
</div>
